export class general{
    constructor(){
        
    }
}